import classNames from "classnames"
import React from "react"

import GatsbyStoryblokImage from "./GatsbyStoryblokImage"
import Section from "./Section"
import Typography from "./Typography"
import LayoutItem from "../../V2/Layouts/LayoutItem"

import { Color } from "@constants/V2/color"
import { getAccentColor, getBackgroundColorClass } from "@utils/V2/color"

interface Props {
  category?: string
  title: string
  subscript?: string
  backgroundColor?: Color
  imageUrl: string
  imageAlt: string
  mobileGridOrder?: number
}

const ArticleHero = ({
  category,
  title,
  subscript,
  backgroundColor = Color.White,
  imageUrl,
  imageAlt,
  mobileGridOrder,
}: Props) => {
  return (
    <LayoutItem
      as={Section}
      className={classNames(getBackgroundColorClass(backgroundColor))}
      mobileGridOrder={mobileGridOrder}
    >
      <div className="flex flex-col gap-8 pb-20 pt-[100px] md:pb-24 md:pt-[124px] lg:pb-40 lg:pt-[180px]">
        {category && (
          <Typography
            text={category}
            size="subscript-lg"
            font="grotesk"
            weight="book"
            color={getAccentColor(backgroundColor)}
            className="uppercase tracking-wide"
          />
        )}
        <Typography
          text={title}
          size="h3"
          font="grotesk"
          weight="book"
          color={getAccentColor(backgroundColor)}
        />
        {subscript && (
          <Typography
            text={subscript}
            size="body-lg"
            font="grotesk"
            weight="book"
            color={getAccentColor(backgroundColor)}
            className="opacity-70"
          />
        )}
      </div>
      <div className="flex">
        <GatsbyStoryblokImage
          aspectRatio="3:4"
          image={imageUrl}
          alt={imageAlt || "Article hero image"}
          className="mx-auto my-20 md:my-24 lg:my-32"
          rounded
        />
      </div>
    </LayoutItem>
  )
}

export default ArticleHero
